module.exports = __webpack_public_path__ + "media/images/buckinghamshire_logo-1db6d68f.png";